const s = {
  name: "Discount",
  dimensions: { width: 24, height: 24 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M10,9c0,0.6-0.4,1-1,1S8,9.6,8,9s0.4-1,1-1S10,8.4,10,9z"/>
		<path class="st0" d="M10,15.4l5.4-5.4L14,8.6L8.6,14L10,15.4z"/>
		<path class="st0" d="M15,16c0.6,0,1-0.4,1-1s-0.4-1-1-1s-1,0.4-1,1S14.4,16,15,16z"/>
		<path class="st0" d="M12,0l3.5,3.5h5v5L24,12l-3.5,3.5v5h-5L12,24l-3.5-3.5h-5v-5L0,12l3.5-3.5v-5h5L12,0z M14.7,5.5L12,2.8
			L9.3,5.5H5.5v3.8L2.8,12l2.7,2.7v3.8h3.8l2.7,2.7l2.7-2.7h3.8v-3.8l2.7-2.7l-2.7-2.7V5.5H14.7z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Discount
};
